/**
 * time related constants
 */

const Time: {[key: string]: number} = {
    REACTION_CLOSE: 300,
    TEN_SECONDS: 10000,
    TWO_DAYS: 172800000,
    FOUR_DAYS: 345600000
};

export {Time};
